@if (pageError) {
  <gbc-error-tile
    [title]="pageError.userTitle"
    [message]="pageError.userMessage">
  </gbc-error-tile>
}

@if (!loading && !pageError) {
  <ng-container [ngTemplateOutlet]="content"></ng-container>
}
